import { IAppState } from '../reducers';

export const getHrState = (state: IAppState) => state.hr;
